import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  FaHome, 
  FaPlusCircle, 
  FaListAlt, 
  FaAngleDoubleLeft, 
  FaAngleDoubleRight, 
  FaSignOutAlt 
} from "react-icons/fa";
import "./Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  // Se inicializa collapsed desde localStorage (si existe)
  const [collapsed, setCollapsed] = useState(
    localStorage.getItem("navbarCollapsed") === "true"
  );

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUserName = localStorage.getItem("userName");
    const storedRole = localStorage.getItem("role");

    if (!token) {
      navigate("/login");
    }

    setUserName(storedUserName || "Usuario");
    setRole(storedRole || "");

    // Aplica la clase al body según el estado persistido
    if (localStorage.getItem("navbarCollapsed") === "true") {
      document.body.classList.add("navbar-collapsed");
    } else {
      document.body.classList.remove("navbar-collapsed");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  const toggleCollapse = () => {
    setCollapsed((prev) => {
      const newState = !prev;
      localStorage.setItem("navbarCollapsed", newState);
      if (newState) {
        document.body.classList.add("navbar-collapsed");
      } else {
        document.body.classList.remove("navbar-collapsed");
      }
      return newState;
    });
  };

  return (
    <>
      <div className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </div>

      <nav className={`navbar ${isOpen ? "open" : ""} ${collapsed ? "collapsed" : ""}`}>
        <div className="title">
          {!collapsed && <h2>S.O.S.P</h2>}
        </div>
        <div className="user-info">
          {!collapsed && <p>Bienvenido, {userName}</p>}
          <ul className="menu">
            <li onClick={() => handleNavigate("/inicio")}>
              <FaHome className="icon" />
              {!collapsed && <span>Inicio</span>}
            </li>
            {role === "admin" && (
              <li onClick={() => handleNavigate("/admin")}>
                <FaPlusCircle className="icon" />
                {!collapsed && <span>Cargar obra</span>}
              </li>
            )}
            {role === "viewer" && (
              <li onClick={() => handleNavigate("/viewer")}>
                <FaListAlt className="icon" />
                {!collapsed && <span>Lista de obras</span>}
              </li>
            )}
          </ul>
        </div>
        <div className="collapse-btn" onClick={toggleCollapse}>
          {collapsed ? (
            <FaAngleDoubleRight className="icon" />
          ) : (
            <FaAngleDoubleLeft className="icon" />
          )}
        </div>
        <div className="logout">
          <button onClick={handleLogout}>
            {collapsed ? <FaSignOutAlt className="icon" /> : "Cerrar Sesión"}
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
